import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import CustomerModalSubtitle from "./CustomerModalSubtitle";
import CrmContactMomentFields from "./CrmContactMomentFields";

const CrmContactMomentModal = ({
  titleKey = "contact_moment",
  open,
  onCancel,
  onOk,
  okTextKey = "save",
  cancelTextKey = "cancel",
  confirmLoading,
  footer,
  width,
  customerName,
  dateTime,
  onDateTimeChange,
  text,
  onTextChange,
  fileList,
  onFileListChange,
  dateTimePlaceholderKey,
  textPlaceholderKey,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t(titleKey)}
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      okText={t(okTextKey)}
      cancelText={t(cancelTextKey)}
      confirmLoading={confirmLoading}
      footer={footer}
      width={width}
    >
      <CustomerModalSubtitle customerName={customerName} />
      <CrmContactMomentFields
        dateTime={dateTime}
        onDateTimeChange={onDateTimeChange}
        text={text}
        onTextChange={onTextChange}
        fileList={fileList}
        onFileListChange={onFileListChange}
        dateTimePlaceholderKey={dateTimePlaceholderKey}
        textPlaceholderKey={textPlaceholderKey}
      />
    </Modal>
  );
};

export default CrmContactMomentModal;
